"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fossato-di-vico": {
    "8fa5ea2e": [{
      "hkey": "0e9f7a74",
      "slug": "fossato-di-vico",
      "name": "Fossato di Vico",
      "primary": true,
      "skipSearch": false
    }],
    "colle-di-fossato": [{
      "hkey": "0e9f7a74",
      "slug": "fossato-di-vico",
      "name": "Fossato di Vico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "390d2cdc": [{
      "hkey": "0e9f7a74",
      "slug": "fossato-di-vico",
      "name": "Fossato di Vico",
      "primary": true,
      "skipSearch": false
    }],
    "fossato-scalo": [{
      "hkey": "0e9f7a74",
      "slug": "fossato-di-vico",
      "name": "Fossato di Vico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a2386669": [{
      "hkey": "0e9f7a74",
      "slug": "fossato-di-vico",
      "name": "Fossato di Vico",
      "primary": true,
      "skipSearch": false
    }],
    "palazzolo": [{
      "hkey": "0e9f7a74",
      "slug": "fossato-di-vico",
      "name": "Fossato di Vico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;